import Select from './Select/Select';
import TextField from './TextField/TextField';
import DatePicker from './DatePicker/DatePicker';
import Autocomplete, {
  AutoCompleteMultiSelect,
} from './Autocomplete/Autocomplete';
import { CompoundMultiSelect } from './MultiSelect/CompoundMultiSelect';
import Checkbox from './CheckBox/Checkbox';
import DataGrid from './DataGrid/DataGrid';
import TextArea from './TextArea/TextArea';
import RadioGroup from './RadioGroup/RadioGroup';
import MultiSelect from './MultiSelect/MultiSelect';
import SwitchLabels from './Switch/Switch';
import { ModalMultiSelect } from './MultiSelect/ModalMultiSelect';
import { TreeModalMultiSelect } from './MultiSelect/TreeModalMultiSelect';
import { FilePicker } from './FilePicker/FilePicker';
import MyLink from './Link/Link';
import { InlineGridTemplate } from './Grid/InlineGridTemplate';
import Card from './Card/Card';
import { Radio } from '@mui/material';

const Controls = {
  Select,
  TextField,
  DatePicker,
  Autocomplete,
  AutoCompleteMultiSelect,
  Checkbox,
  DataGrid,
  TextArea,
  RadioGroup,
  MultiSelect,
  CompoundMultiSelect,
  SwitchLabels,
  MyLink,
  //TreeModalMultiSelectOld,
  TreeModalMultiSelect,
  InlineGridTemplate,
  ModalMultiSelect,
  Radio,
  Card,
  FilePicker,
};

export default Controls;
